<template>
  <header>
    <div class="container">
      <div class="row row-wrap pt-3">
        <div class="header-title col-sm text-center text-sm-left">
          <img src="@/assets/images/logo-heppi.png" srcset="@/assets/images/logo-heppi@2x.png 2x" height="40px">
          <h1>
            {{ celebration }}
          </h1>
        </div>
        <div class="header-status col-sm text-center text-sm-right">
          <h2 v-html="description" />
          <span v-if="status" class="badge badge-sm-large" :class="'badge-' + statusColor">{{ status | statusDescription }}</span>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'invoiceFooter',
  props: ['status', 'celebration', 'description'],
  computed: {
    statusColor () {
      if (this.status === 'paid') return 'success'
      if (this.status === 'canceled' || this.status === 'undefined' || this.status === 'renegotiated') return 'mute'
      if (this.status === 'processing') return 'warning'
      if (this.status === 'late') return 'danger'
      if (this.status === 'pending') return 'secondary'
      return 'primary'
    }
  },
  filters: {
    statusDescription (val) {
      if (val === 'paid') return 'Pago'
      if (val === 'canceled') return 'Cancelado'
      if (val === 'undefined') return 'Problema na fatura'
      if (val === 'processing') return 'Em processamento'
      if (val === 'late') return 'Atrasado'
      if (val === 'pending') return 'Em aberto'
      if (val === 'renegotiated') return 'Renegociado'
      return 'Atualizando'
    }
  }
}
</script>
